import styled from 'styled-components';
import LoginImage from '../../assets/Images/Squid/LoginImage.png';
import { theme } from '../../styles/theme';

const { mainColorButtonHover, mainColor } = theme.colors;

export const Container = styled.div`
  display: flex;
  overflow: hidden;
`;

export const BackgroundImage = styled.div`
  background-image: url(${LoginImage});
  min-height: 100vh;
  min-width: 50vw;
  background-size: 100% 100%;
  -o-background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
`;

export const LoginContainer = styled.div`
  width: 50vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TokenModalContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ImageContainer = styled.div`
  margin: ${(props) => props.margin || '0'};
  width: ${(props) => props.width || 'auto'};
  max-width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  img {
    width: 100%;
    height: auto;
  }

  .imageLogo {
    width: 13.177159590043924vw;
    height: auto;
  }
`;

export const Footer = styled.div`
  display: flex;
  position: absolute;
  bottom: 0;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2.778vw;
`;

export const Slogan = styled.div`
  width: 50vw;
  display: flex;
  align-items: center;
  font-weight: 600;
  cursor: pointer;
  justify-content: flex-start;
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  color: ${(props) => props.color || 'black'};

  & span {
    color: #ff557e;
    font-size: 4.53857791225416vh;
    font-weight: bold;
  }
`;

export const LoginInfo = styled.div`
  width: 31.25vw;
  display: flex;
  height: 5.347vw;
  justify-content: space-evenly;
  flex-direction: column;
  .MuiTypography-h4 {
    font-weight: 600;
    font-family: 'Poppins', 'Helvetica', 'Arial', sans-serif;
  }
`;

export const ReSendText = styled.b`
  color: ${(props) => props?.color};
`;

export const ForgotPassword = styled.div`
  cursor: pointer;
  color: ${mainColor};
  .MuiTypography-h6 {
    cursor: pointer;
  }
`;

export const ResendLink = styled.b`
  cursor: pointer;
  padding: 0 5px;
  border-radius: 5px;

  &:hover {
    background: ${mainColorButtonHover};
    color: white;
  }
`;
